export default __webpack_public_path__ + "ddb5e7b43fef3645914db204e123372d.svg";